export default __webpack_public_path__ + "static/media/six.bd765919.svg";